const CADASTRO_CONTATO_RECEBIDO_PATH = "/cadastro/contato-recebido"

function withoutTrailingSlash(pathname: string): string {
  if (pathname.length <= 1) return pathname
  return pathname.replace(/\/+$/, "")
}

/**
 * Shell do cadastro, com o card "Dúvidas?".
 * `/cadastro/contato-recebido` é a página de obrigado da campanha e fica de fora,
 * com ou sem barra no final.
 */
export function isCadastroSignupShellPath(pathname: string | null): boolean {
  if (!pathname) return false
  const path = withoutTrailingSlash(pathname)
  if (path === CADASTRO_CONTATO_RECEBIDO_PATH) return false
  return path === "/cadastro" || path.startsWith("/cadastro/")
}

/** Rotas do fluxo cadastro/login onde o suporte no mobile é inline (acima dos pilares). */
export function isCadastroEntrarSupportInlinePath(pathname: string | null): boolean {
  if (!pathname) return false
  if (pathname === "/cadastro" || pathname.startsWith("/cadastro/")) return true
  if (pathname === "/entrar" || pathname.startsWith("/entrar/")) return true
  return false
}
